export interface NavigationItem {
  id: string;
  title: string;
  type: 'item' | 'collapse' | 'group';
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  children?: NavigationItem[];
  role?: string[];
  isMainParent?: boolean;
}

export const NavigationItems: NavigationItem[] = [
  // Dashboard se mantiene disponible internamente (/dashboard),
  // pero NO debe mostrarse en el menú lateral.
  {
    id: 'atencion',
    title: 'Caja',
    type: 'group',
    icon: 'icon-navigation',
    children: [
      {
        id: 'default',
        title: 'Caja',
        type: 'item',
        classes: 'nav-item',
        url: '/caja',
        icon: 'ti ti-dashboard',
        breadcrumbs: false
      }
      ,
      {
        id: 'lista-atenciones',
        title: 'Registro de Caja',
        type: 'item',
        classes: 'nav-item',
        url: '/caja/registrocaja',
        icon: 'ti ti-list',
        breadcrumbs: true
      },
      {
        id: 'turnos-caja',
        title: 'Aperturas y Cierres',
        type: 'item',
        classes: 'nav-item',
        url: '/caja/turnos',
        icon: 'ti ti-cash',
        breadcrumbs: true
      }
    ]
  },
  {
    id: 'operaciones',
    title: 'Operaciones Diarias',
    type: 'group',
    icon: 'icon-navigation',
    children: [
      {
        id: 'pacientes',
        title: 'Pacientes',
        type: 'collapse',
        icon: 'ti ti-users',
        children: [
          {
            id: 'lista-pacientes',
            title: 'Lista de Pacientes',
            type: 'item',
            url: '/pacientes/lista',
            breadcrumbs: true
          },
         
        ]
      },
      {
        id: 'servicios',
        title: 'Servicios',
        type: 'collapse',
        icon: 'ti ti-stethoscope',
        children: [
          {
            id: 'lista-servicios',
            title: 'Administrar Servicios',
            type: 'item',
            url: '/servicios/lista',
            breadcrumbs: true
          },
          {
            id: 'especialidades',
            title: 'Especialidades',
            type: 'item',
            url: '/especialidades/lista',
            breadcrumbs: true
          }
        ]
      },
      {
        id: 'cirugias',
        title: 'Cirugías',
        type: 'collapse',
        icon: 'ti ti-activity-heartbeat',
        children: [
          {
            id: 'reservas-cirugias',
            title: 'Reservas de Cirugías',
            type: 'item',
            url: '/cirugias/reservas',
            breadcrumbs: true
          }
        ]
      },
      {
        id: 'agenda',
        title: 'Agenda',
        type: 'collapse',
        icon: 'ti ti-calendar',
        children: [
          {
            id: 'horarios-medicos',
            title: 'Horarios Médicos',
            type: 'item',
            url: '/horarios/lista',
            breadcrumbs: true
          },
          {
            id: 'citas',
            title: 'Citas / Agendamientos',
            type: 'item',
            url: '/citas/lista',
            breadcrumbs: true
          }
          ,
          {
            id: 'historial-medico',
            title: 'Historial Médico',
            type: 'item',
            url: '/historial-medico/lista',
            breadcrumbs: true
          }
        ]
      },
      {
        id: 'medicos',
        title: 'Médicos',
        type: 'collapse',
        icon: 'ti ti-user-heart',
        children: [
          {
            id: 'lista-medicos',
            title: 'Lista de Médicos',
            type: 'item',
            url: '/medicos/lista',
            breadcrumbs: true
          }
        ]
      },
      {
        id: 'internaciones',
        title: 'Internaciones',
        type: 'collapse',
        icon: 'ti ti-bed',
        children: [
          {
            id: 'lista-internaciones',
            title: 'Lista de internaciones',
            type: 'item',
            url: '/internaciones/lista',
            breadcrumbs: true
          }
        ]
      }
    ]
  },
  {
    id: 'farmacia',
    title: 'Farmacia',
    type: 'group',
    icon: 'icon-navigation',
    children: [
      {
        id: 'farmacia-caja',
        title: 'Caja y ventas',
        type: 'item',
        url: '/farmacia/caja',
        icon: 'ti ti-shopping-cart',
        breadcrumbs: true
      },
      {
        id: 'farmacia-productos',
        title: 'Medicamentos y productos',
        type: 'item',
        url: '/farmacia/productos',
        icon: 'ti ti-pill',
        breadcrumbs: true
      },
      {
        id: 'farmacia-compras',
        title: 'Compras',
        type: 'item',
        url: '/farmacia/compras',
        icon: 'ti ti-package-import',
        breadcrumbs: true
      },
      {
        id: 'farmacia-inventario',
        title: 'Inventario',
        type: 'item',
        url: '/farmacia/inventario',
        icon: 'ti ti-clipboard-data',
        breadcrumbs: true
      },
      {
        id: 'farmacia-almacenes',
        title: 'Almacenes',
        type: 'item',
        url: '/farmacia/almacenes',
        icon: 'ti ti-building-warehouse',
        breadcrumbs: true
      },
      {
        id: 'farmacia-sucursales',
        title: 'Sucursales',
        type: 'item',
        url: '/farmacia/sucursales',
        icon: 'ti ti-building-store',
        breadcrumbs: true
      },
      {
        id: 'farmacia-reportes',
        title: 'Reportes',
        type: 'item',
        url: '/farmacia/reportes',
        icon: 'ti ti-chart-bar',
        breadcrumbs: true
      }
    ]
  },
  /*
  {
    id: 'page',
    title: 'Pages',
    type: 'group',
    icon: 'icon-navigation',
    children: [
      {
        id: 'Authentication',
        title: 'Authentication',
        type: 'collapse',
        icon: 'ti ti-key',
        children: [
          {
            id: 'login',
            title: 'Login',
            type: 'item',
            url: '/authentication/login',
            target: true,
            breadcrumbs: false
          },
          {
            id: 'register',
            title: 'Register',
            type: 'item',
            url: '/register',
            target: true,
            breadcrumbs: false
          }
        ]
      }
    ]
  }*/
  {
    id: 'doctor',
    title: 'Doctor',
    type: 'group',
    icon: 'icon-navigation',
    children: [
      {
        id: 'agenda',
        title: 'Mi agenda',
        type: 'item',
        classes: 'nav-item',
        url: '/doctor/agenda',
        icon: 'ti ti-calendar'
      },
      {
        id: 'honorarios',
        title: 'Honorarios',
        type: 'item',
        classes: 'nav-item',
        url: '/doctor/honorarios',
        icon: 'ti ti-cash',
        hidden: true
      },
      // Configuración: eliminada del panel.
    ]
  },
  
  // MÉDICOS
/*  {
    id: 'clinica-medicos',
    title: ' Médicos',
    type: 'group',
    icon: 'icon-navigation',
    children: [
      {
        id: 'medicos',
        title: 'Médicos',
        type: 'collapse',
        icon: 'ti ti-stethoscope',
        children: [
          {
            id: 'lista-medicos',
            title: 'Lista de Médicos',
            type: 'item',
            url: '/medicos/lista',
            breadcrumbs: true
          },
          {
            id: 'registrar-medico',
            title: 'Registrar Médico',
            type: 'item',
            url: '/medicos/registrar',
            breadcrumbs: true
          },
          {
            id: 'editar-medico',
            title: 'Editar Médico',
            type: 'item',
            url: '/medicos/editar',
            breadcrumbs: true
          },
          {
            id: 'asignar-especialidades',
            title: 'Asignar Especialidades',
            type: 'item',
            url: '/medicos/especialidades',
            breadcrumbs: true
          },
          {
            id: 'configurar-honorarios',
            title: 'Configurar Honorarios',
            type: 'item',
            url: '/medicos/honorarios',
            breadcrumbs: true
          }
        ]
      },
      {
        id: 'horarios',
        title: 'Horarios',
        type: 'collapse',
        icon: 'ti ti-clock',
        children: [
          {
            id: 'calendario-disponibilidad',
            title: 'Calendario de Disponibilidad',
            type: 'item',
            url: '/horarios/calendario',
            breadcrumbs: true
          },
          {
            id: 'horarios-recurrentes',
            title: 'Configurar Horarios Recurrentes',
            type: 'item',
            url: '/horarios/recurrentes',
            breadcrumbs: true
          },
          {
            id: 'horarios-especificos',
            title: 'Horarios de Fecha Específica',
            type: 'item',
            url: '/horarios/especificos',
            breadcrumbs: true
          },
          {
            id: 'consultar-disponibilidad',
            title: 'Consultar Disponibilidad',
            type: 'item',
            url: '/horarios/disponibilidad',
            breadcrumbs: true
          }
        ]
      },
      {
        id: 'consultas',
        title: 'Consultas',
        type: 'collapse',
        icon: 'ti ti-clipboard',
        children: [
          {
            id: 'registrar-consulta',
            title: 'Registrar Consulta',
            type: 'item',
            url: '/consultas/registrar',
            breadcrumbs: true
          },
          {
            id: 'historial-consultas',
            title: 'Historial de Consultas',
            type: 'item',
            url: '/consultas/historial',
            breadcrumbs: true
          },
          {
            id: 'consultas-medico',
            title: 'Consultas por Médico',
            type: 'item',
            url: '/consultas/por-medico',
            breadcrumbs: true
          },
          {
            id: 'recetas-medicas',
            title: 'Recetas Médicas',
            type: 'item',
            url: '/consultas/recetas',
            breadcrumbs: true
          }
        ]
      },
      {
        id: 'cirugias',
        title: 'Cirugías',
        type: 'collapse',
        icon: 'ti ti-surgical-scalpel',
        children: [
          {
            id: 'programar-cirugia',
            title: 'Programar Cirugía',
            type: 'item',
            url: '/cirugias/programar',
            breadcrumbs: true
          },
          {
            id: 'lista-cirugias',
            title: 'Lista de Cirugías',
            type: 'item',
            url: '/cirugias/lista',
            breadcrumbs: true
          },
          {
            id: 'modificar-costo',
            title: 'Modificar Costo de Cirugía',
            type: 'item',
            url: '/cirugias/modificar-costo',
            breadcrumbs: true
          },
          {
            id: 'tipos-cirugia',
            title: 'Tipos de Cirugía',
            type: 'item',
            url: '/cirugias/tipos',
            breadcrumbs: true
          },
          {
            id: 'reportes-cirugias',
            title: 'Reportes de Cirugías',
            type: 'item',
            url: '/cirugias/reportes',
            breadcrumbs: true
          }
        ]
      },
      {
        id: 'internaciones',
        title: 'Internaciones',
        type: 'collapse',
        icon: 'ti ti-bed',
        children: [
          {
            id: 'lista-internaciones',
            title: 'Lista de internaciones',
            type: 'item',
            url: '/internaciones/lista',
            breadcrumbs: true
          }
        ]
      },
      {
        id: 'especialidades-medicas',
        title: 'Especialidades Médicas',
        type: 'collapse',
        icon: 'ti ti-first-aid-kit',
        children: [
          {
            id: 'lista-especialidades',
            title: 'Lista de Especialidades',
            type: 'item',
            url: '/especialidades/lista',
            breadcrumbs: true
          },
          {
            id: 'registrar-especialidad',
            title: 'Registrar Especialidad',
            type: 'item',
            url: '/especialidades/registrar',
            breadcrumbs: true
          },
          {
            id: 'editar-especialidad',
            title: 'Editar Especialidad',
            type: 'item',
            url: '/especialidades/editar',
            breadcrumbs: true
          }
        ]
      }
    ]
  },

  // ============================================
  // INVENTARIO
  // ============================================
  {
    id: 'inventario',
    title: 'Inventario',
    type: 'group',
    icon: 'icon-navigation',
    hidden: true,
    children: [
      {
        id: 'medicamentos',
        title: 'Medicamentos',
        type: 'collapse',
        icon: 'ti ti-pill',
        children: [
          {
            id: 'inventario-medicamentos',
            title: 'Inventario de Medicamentos',
            type: 'item',
            url: '/medicamentos/inventario',
            breadcrumbs: true
          },
          {
            id: 'registrar-medicamento',
            title: 'Registrar Medicamento',
            type: 'item',
            url: '/medicamentos/registrar',
            breadcrumbs: true
          },
          {
            id: 'editar-medicamento',
            title: 'Editar Medicamento',
            type: 'item',
            url: '/medicamentos/editar',
            breadcrumbs: true
          },
          {
            id: 'control-stock',
            title: 'Control de Stock',
            type: 'item',
            url: '/medicamentos/stock',
            breadcrumbs: true
          },
          {
            id: 'alertas-vencimiento',
            title: 'Alertas de Vencimiento',
            type: 'item',
            url: '/medicamentos/alertas',
            breadcrumbs: true
          },
          {
            id: 'movimientos-inventario',
            title: 'Movimientos de Inventario',
            type: 'item',
            url: '/medicamentos/movimientos',
            breadcrumbs: true
          }
        ]
      }
    ]
  },

  // ============================================
  // FINANZAS
  // ============================================
  {
    id: 'finanzas',
    title: 'Finanzas',
    type: 'group',
    icon: 'icon-navigation',
    children: [
      {
        id: 'libro-diario',
        title: 'Libro Diario',
        type: 'collapse',
        icon: 'ti ti-book',
        children: [
          {
            id: 'libro-dia',
            title: 'Ver Libro del Día',
            type: 'item',
            url: '/finanzas/libro-diario',
            breadcrumbs: true
          },
          {
            id: 'registrar-egreso',
            title: 'Registrar Egreso/Gasto',
            type: 'item',
            url: '/finanzas/registrar-egreso',
            breadcrumbs: true
          },
          {
            id: 'libro-anteriores',
            title: 'Libro de Fechas Anteriores',
            type: 'item',
            url: '/finanzas/libro-anteriores',
            breadcrumbs: true
          },
          {
            id: 'exportar-libro',
            title: 'Exportar a PDF/Excel',
            type: 'item',
            url: '/finanzas/exportar-libro',
            breadcrumbs: true
          },
          {
            id: 'imprimir-libro',
            title: 'Imprimir Libro Diario',
            type: 'item',
            url: '/finanzas/imprimir-libro',
            breadcrumbs: true
          }
        ]
      },
      {
        id: 'arqueo-caja',
        title: 'Arqueo de Caja',
        type: 'collapse',
        icon: 'ti ti-cash-register',
        children: [
          {
            id: 'apertura-caja',
            title: 'Apertura de Caja',
            type: 'item',
            url: '/finanzas/apertura-caja',
            breadcrumbs: true
          },
          {
            id: 'arqueo-actual',
            title: 'Arqueo Actual',
            type: 'item',
            url: '/finanzas/arqueo-actual',
            breadcrumbs: true
          },
          {
            id: 'cierre-caja',
            title: 'Cierre de Caja',
            type: 'item',
            url: '/finanzas/cierre-caja',
            breadcrumbs: true
          },
          {
            id: 'arqueos-anteriores',
            title: 'Consultar Arqueos Anteriores',
            type: 'item',
            url: '/finanzas/arqueos-anteriores',
            breadcrumbs: true
          },
          {
            id: 'imprimir-arqueo',
            title: 'Imprimir Reporte de Arqueo',
            type: 'item',
            url: '/finanzas/imprimir-arqueo',
            breadcrumbs: true
          }
        ]
      },
      {
        id: 'historial-pagos',
        title: 'Historial de Pagos',
        type: 'collapse',
        icon: 'ti ti-history',
        children: [
          {
            id: 'todos-pagos',
            title: 'Todos los Pagos',
            type: 'item',
            url: '/finanzas/pagos/todos',
            breadcrumbs: true
          },
          {
            id: 'filtrar-fecha',
            title: 'Filtrar por Fecha',
            type: 'item',
            url: '/finanzas/pagos/por-fecha',
            breadcrumbs: true
          },
          {
            id: 'filtrar-paciente',
            title: 'Filtrar por Paciente',
            type: 'item',
            url: '/finanzas/pagos/por-paciente',
            breadcrumbs: true
          },
          {
            id: 'filtrar-metodo',
            title: 'Filtrar por Método de Pago',
            type: 'item',
            url: '/finanzas/pagos/por-metodo',
            breadcrumbs: true
          },
          {
            id: 'ver-recibo',
            title: 'Ver Recibo',
            type: 'item',
            url: '/finanzas/pagos/ver-recibo',
            breadcrumbs: true
          },
          {
            id: 'reimprimir-recibo',
            title: 'Reimprimir Recibo',
            type: 'item',
            url: '/finanzas/pagos/reimprimir',
            breadcrumbs: true
          },
          {
            id: 'anular-pago',
            title: 'Anular Pago',
            type: 'item',
            url: '/finanzas/pagos/anular',
            breadcrumbs: true
          }
        ]
      },
      {
        id: 'honorarios-medicos',
        title: 'Honorarios Médicos',
        type: 'collapse',
        icon: 'ti ti-wallet',
        children: [
          {
            id: 'configurar-honorarios-medicos',
            title: 'Configurar Honorarios',
            type: 'item',
            url: '/finanzas/honorarios/configurar',
            breadcrumbs: true
          },
          {
            id: 'honorarios-pendientes',
            title: 'Honorarios Pendientes',
            type: 'item',
            url: '/finanzas/honorarios/pendientes',
            breadcrumbs: true
          },
          {
            id: 'pagar-medicos',
            title: 'Pagar a Médicos',
            type: 'item',
            url: '/finanzas/honorarios/pagar',
            breadcrumbs: true
          },
          {
            id: 'historial-pagos-medicos',
            title: 'Historial de Pagos a Médicos',
            type: 'item',
            url: '/finanzas/honorarios/historial',
            breadcrumbs: true
          },
          {
            id: 'reporte-medico',
            title: 'Reporte por Médico',
            type: 'item',
            url: '/finanzas/honorarios/por-medico',
            breadcrumbs: true
          },
          {
            id: 'resumen-mensual',
            title: 'Resumen Mensual',
            type: 'item',
            url: '/finanzas/honorarios/resumen',
            breadcrumbs: true
          }
        ]
      }
    ]
  },

  // ============================================
  // REPORTES Y ANÁLISIS
  // ============================================
  {
    id: 'reportes',
    title: 'Reportes y Análisis',
    type: 'group',
    icon: 'icon-navigation',
    children: [
      {
        id: 'dashboard-reportes',
        title: 'Dashboard de Reportes',
        type: 'item',
        classes: 'nav-item',
        url: '/reportes/dashboard',
        icon: 'ti ti-chart-line',
        breadcrumbs: true
      },
      {
        id: 'reportes-financieros',
        title: 'Reportes Financieros',
        type: 'collapse',
        icon: 'ti ti-report-money',
        hidden: true,
        children: [
          {
            id: 'reporte-ingresos',
            title: 'Reporte de Ingresos',
            type: 'item',
            url: '/reportes/financieros/ingresos',
            breadcrumbs: true
          },
          {
            id: 'reporte-egresos',
            title: 'Reporte de Egresos',
            type: 'item',
            url: '/reportes/financieros/egresos',
            breadcrumbs: true
          },
          {
            id: 'utilidad-perdida',
            title: 'Utilidad y Pérdida',
            type: 'item',
            url: '/reportes/financieros/utilidad',
            breadcrumbs: true
          },
          {
            id: 'flujo-caja',
            title: 'Flujo de Caja',
            type: 'item',
            url: '/reportes/financieros/flujo',
            breadcrumbs: true
          },
          {
            id: 'honorarios-pagados',
            title: 'Honorarios Pagados',
            type: 'item',
            url: '/reportes/financieros/honorarios-pagados',
            breadcrumbs: true
          },
          {
            id: 'comparativo-mensual',
            title: 'Comparativo Mensual',
            type: 'item',
            url: '/reportes/financieros/comparativo',
            breadcrumbs: true
          }
        ]
      },
      {
        id: 'reportes-medicos',
        title: 'Reportes Médicos',
        type: 'collapse',
        icon: 'ti ti-report-medical',
        hidden: true,
        children: [
          {
            id: 'consultas-realizadas',
            title: 'Consultas Realizadas',
            type: 'item',
            url: '/reportes/medicos/consultas',
            breadcrumbs: true
          },
          {
            id: 'cirugias-realizadas',
            title: 'Cirugías Realizadas',
            type: 'item',
            url: '/reportes/medicos/cirugias',
            breadcrumbs: true
          },
          {
            id: 'internaciones-reporte',
            title: 'Internaciones',
            type: 'item',
            url: '/reportes/medicos/internaciones',
            breadcrumbs: true
          },
          {
            id: 'estadisticas-generales',
            title: 'Estadísticas Generales',
            type: 'item',
            url: '/reportes/medicos/estadisticas',
            breadcrumbs: true
          }
        ]
      },
      {
        id: 'reportes-citas',
        title: 'Reportes de Citas',
        type: 'collapse',
        icon: 'ti ti-calendar-stats',
        hidden: true,
        children: [
          {
            id: 'citas-medico',
            title: 'Citas por Médico',
            type: 'item',
            url: '/reportes/citas/por-medico',
            breadcrumbs: true
          },
          {
            id: 'citas-especialidad',
            title: 'Citas por Especialidad',
            type: 'item',
            url: '/reportes/citas/por-especialidad',
            breadcrumbs: true
          },
          {
            id: 'citas-canceladas',
            title: 'Citas Canceladas',
            type: 'item',
            url: '/reportes/citas/canceladas',
            breadcrumbs: true
          },
          {
            id: 'citas-reprogramadas',
            title: 'Citas Reprogramadas',
            type: 'item',
            url: '/reportes/citas/reprogramadas',
            breadcrumbs: true
          },
          {
            id: 'cumplimiento-citas',
            title: 'Cumplimiento de Citas',
            type: 'item',
            url: '/reportes/citas/cumplimiento',
            breadcrumbs: true
          }
        ]
      },
      {
        id: 'reportes-pacientes',
        title: 'Reportes de Pacientes',
        type: 'collapse',
        icon: 'ti ti-users',
        hidden: true,
        children: [
          {
            id: 'pacientes-nuevos',
            title: 'Pacientes Nuevos',
            type: 'item',
            url: '/reportes/pacientes/nuevos',
            breadcrumbs: true
          },
          {
            id: 'pacientes-activos',
            title: 'Pacientes Activos',
            type: 'item',
            url: '/reportes/pacientes/activos',
            breadcrumbs: true
          },
          {
            id: 'estadisticas-demograficas',
            title: 'Estadísticas Demográficas',
            type: 'item',
            url: '/reportes/pacientes/demograficas',
            breadcrumbs: true
          },
          {
            id: 'servicios-solicitados',
            title: 'Servicios más Solicitados',
            type: 'item',
            url: '/reportes/pacientes/servicios',
            breadcrumbs: true
          },
          {
            id: 'analisis-frecuencia',
            title: 'Análisis de Frecuencia',
            type: 'item',
            url: '/reportes/pacientes/frecuencia',
            breadcrumbs: true
          }
        ]
      },
      {
        id: 'reportes-inventario',
        title: 'Reportes de Inventario',
        type: 'collapse',
        icon: 'ti ti-package',
        hidden: true,
        children: [
          {
            id: 'stock-actual',
            title: 'Stock Actual',
            type: 'item',
            url: '/reportes/inventario/stock',
            breadcrumbs: true
          },
          {
            id: 'medicamentos-vencer',
            title: 'Medicamentos por Vencer',
            type: 'item',
            url: '/reportes/inventario/vencer',
            breadcrumbs: true
          },
          {
            id: 'movimientos-inventario-reporte',
            title: 'Movimientos de Inventario',
            type: 'item',
            url: '/reportes/inventario/movimientos',
            breadcrumbs: true
          },
          {
            id: 'consumo-periodo',
            title: 'Consumo por Período',
            type: 'item',
            url: '/reportes/inventario/consumo',
            breadcrumbs: true
          }
        ]
      }
    ]
  },*/

  // ADMINISTRACIÓN
  {
    id: 'administracion',
    title: 'Administración',
    type: 'group',
    icon: 'icon-navigation',
    children: [
      {
        id: 'usuarios',
        title: 'Usuarios',
        type: 'item',
        classes: 'nav-item',
        url: '/usuarios/list',
        icon: 'ti ti-user'
      },
      {
        id: 'rol',
        title: 'Roles',
        type: 'item',
        classes: 'nav-item',
        url: '/roles/list',
        icon: 'ti ti-mask'
      }
    ]
  },
  /*
  {
    id: 'administracion',
    title: 'Administración',
    type: 'group',
    icon: 'icon-navigation',
    children: [
      {
        id: 'usuarios',
        title: 'Usuarios',
        type: 'collapse',
        icon: 'ti ti-briefcase',
        children: [
          {
            id: 'lista-empleados',
            title: 'Lista de Empleados',
            type: 'item',
            url: '/admin/empleados/lista',
            breadcrumbs: true
          },
          {
            id: 'registrar-empleado',
            title: 'Registrar Empleado',
            type: 'item',
            url: '/admin/empleados/registrar',
            breadcrumbs: true
          },
          {
            id: 'editar-empleado',
            title: 'Editar Empleado',
            type: 'item',
            url: '/admin/empleados/editar',
            breadcrumbs: true
          },
          {
            id: 'detalle-empleado',
            title: 'Ver Detalle',
            type: 'item',
            url: '/admin/empleados/detalle',
            breadcrumbs: true
          },
          {
            id: 'activar-empleado',
            title: 'Activar/Desactivar',
            type: 'item',
            url: '/admin/empleados/activar',
            breadcrumbs: true
          }
        ]
      },
      {
        id: 'seguridad',
        title: 'Seguridad',
        type: 'collapse',
        icon: 'ti ti-lock',
        children: [
          {
            id: 'usuarios',
            title: 'Usuarios',
            type: 'collapse',
            icon: 'ti ti-user',
            children: [
              {
                id: 'lista-usuarios',
                title: 'Lista de Usuarios',
                type: 'item',
                url: '/admin/seguridad/usuarios/lista',
                breadcrumbs: true
              },
              {
                id: 'crear-usuario',
                title: 'Crear Usuario',
                type: 'item',
                url: '/admin/seguridad/usuarios/crear',
                breadcrumbs: true
              },
              {
                id: 'editar-usuario',
                title: 'Editar Usuario',
                type: 'item',
                url: '/admin/seguridad/usuarios/editar',
                breadcrumbs: true
              },
              {
                id: 'asignar-roles',
                title: 'Asignar Roles',
                type: 'item',
                url: '/admin/seguridad/usuarios/roles',
                breadcrumbs: true
              },
              {
                id: 'cambiar-contrasena',
                title: 'Cambiar Contraseña',
                type: 'item',
                url: '/admin/seguridad/usuarios/contrasena',
                breadcrumbs: true
              },
              {
                id: 'activar-usuario',
                title: 'Activar/Desactivar',
                type: 'item',
                url: '/admin/seguridad/usuarios/activar',
                breadcrumbs: true
              }
            ]
          },
          {
            id: 'roles',
            title: 'Roles',
            type: 'collapse',
            icon: 'ti ti-mask',
            children: [
              {
                id: 'lista-roles',
                title: 'Lista de Roles',
                type: 'item',
                url: '/admin/seguridad/roles/lista',
                breadcrumbs: true
              },
              {
                id: 'crear-rol',
                title: 'Crear Rol',
                type: 'item',
                url: '/admin/seguridad/roles/crear',
                breadcrumbs: true
              },
              {
                id: 'editar-rol',
                title: 'Editar Rol',
                type: 'item',
                url: '/admin/seguridad/roles/editar',
                breadcrumbs: true
              },
              {
                id: 'asignar-permisos',
                title: 'Asignar Permisos',
                type: 'item',
                url: '/admin/seguridad/roles/permisos',
                breadcrumbs: true
              },
              {
                id: 'activar-rol',
                title: 'Activar/Desactivar',
                type: 'item',
                url: '/admin/seguridad/roles/activar',
                breadcrumbs: true
              }
            ]
          },
          {
            id: 'permisos',
            title: 'Permisos',
            type: 'collapse',
            icon: 'ti ti-key',
            children: [
              {
                id: 'lista-permisos',
                title: 'Lista de Permisos',
                type: 'item',
                url: '/admin/seguridad/permisos/lista',
                breadcrumbs: true
              },
              {
                id: 'crear-permiso',
                title: 'Crear Permiso',
                type: 'item',
                url: '/admin/seguridad/permisos/crear',
                breadcrumbs: true
              },
              {
                id: 'editar-permiso',
                title: 'Editar Permiso',
                type: 'item',
                url: '/admin/seguridad/permisos/editar',
                breadcrumbs: true
              },
              {
                id: 'permisos-modulo',
                title: 'Permisos por Módulo',
                type: 'item',
                url: '/admin/seguridad/permisos/modulo',
                breadcrumbs: true
              }
            ]
          }
        ]
      },
      {
        id: 'configuracion',
        title: 'Configuración',
        type: 'collapse',
        icon: 'ti ti-settings',
        children: [
          {
            id: 'info-clinica',
            title: 'Información de la Clínica',
            type: 'item',
            url: '/admin/configuracion/clinica',
            breadcrumbs: true
          },
          {
            id: 'servicios-medicos',
            title: 'Servicios Médicos',
            type: 'item',
            url: '/admin/configuracion/servicios',
            breadcrumbs: true
          },
          {
            id: 'categorias-servicios',
            title: 'Categorías de Servicios',
            type: 'item',
            url: '/admin/configuracion/categorias',
            breadcrumbs: true
          },
          {
            id: 'metodos-pago',
            title: 'Métodos de Pago',
            type: 'item',
            url: '/admin/configuracion/metodos-pago',
            breadcrumbs: true
          },
          {
            id: 'especialidades-config',
            title: 'Especialidades Médicas',
            type: 'item',
            url: '/admin/configuracion/especialidades',
            breadcrumbs: true
          },
          {
            id: 'tipos-cirugia-config',
            title: 'Tipos de Cirugía',
            type: 'item',
            url: '/admin/configuracion/tipos-cirugia',
            breadcrumbs: true
          },
          {
            id: 'configuracion-general',
            title: 'Configuración General',
            type: 'item',
            url: '/admin/configuracion/general',
            breadcrumbs: true
          }
        ]
      }
    ]
  },*/

  // MI PERFIL
  /*
  {
    id: 'perfil',
    title: 'Mi Perfil',
    type: 'group',
    icon: 'icon-navigation',
    children: [
      {
        id: 'mi-perfil',
        title: 'Mi Perfil',
        type: 'collapse',
        icon: 'ti ti-user-circle',
        children: [
          {
            id: 'ver-perfil',
            title: 'Ver Mi Perfil',
            type: 'item',
            url: '/perfil/ver',
            breadcrumbs: true
          },
          {
            id: 'editar-perfil',
            title: 'Editar Información Personal',
            type: 'item',
            url: '/perfil/editar',
            breadcrumbs: true
          },
          {
            id: 'cambiar-contrasena-perfil',
            title: 'Cambiar Contraseña',
            type: 'item',
            url: '/perfil/cambiar-contrasena',
            breadcrumbs: true
          },
          {
            id: 'notificaciones',
            title: 'Configuración de Notificaciones',
            type: 'item',
            url: '/perfil/notificaciones',
            breadcrumbs: true
          }
        ]
      }
    ]
  }*/
];
